export const HELP = {
  MEAL: [
    {
      name: '质量管理',
      data: [
        ['在线质检系统', '质量在线质检，精准计算合格率、返工率', '管理端：Windows/Mac<br>应用端：Android', '工位机'],
        ['条码、二维码溯源', '基于条码、二维码实现溯源管理，适用于任何行业', '管理端：Windows/Mac<br>应用端：Android/iOS 11.3以上', '手机、手持机'],
        ['码类防串货', '基于条码、二维码实现物品防串功能', '管理端：Windows/Mac<br>应用端：Android/iOS 11.3以上', '手机、手持机']
      ]
      // ,
      // price: ['软件免费']
    }, {
      name: '办公管理',
      data: [
        ['达铃多信源考勤', '基于人脸识别、wifi、手机mac地址等多信源信号实现智慧考勤', '管理端：Windows/Mac<br>应用端：Android/iOS', '手机'],
        ['智慧云访客', '基于RFID、二维码实现访客登记、拜访、预约', '管理端：Windows/Mac<br>应用端：Android/iOS', '手机、扫码器、摄像头、RFID'],
        ['会议管理系统', '会议室在线预约，会议通知', '管理端：Windows/Mac<br>应用端：Android', '触摸屏'],
        ['资产管理系统', '质量在线质检，精准计算合格率、返工率', '管理端：Windows/Mac<br>应用端：Android/iOS', '手机、手持机、RFID'],
      ]
      // ,
      // price: ['软件免费']
    }, {
      name: '防伪管理',
      data: [
        ['公安三所防伪溯源一体化', '与公安部第三研究所防伪事业部共建的平台实现产品防伪溯源功能，适用于服装、箱包、奢侈品、珠宝、酒、茶、母婴产品等领域', '管理端：Windows/Mac<br>应用端：Android/iOS 11.3以上', '手机、RFID'],
        ['RFID防串货', '基于RFID的防串功能', '管理端：Windows/Mac<br>应用端：Windows/Android', '手机、手持机、RFID'],
        ['物联网电子商务', '只需一台手持机即可对货物和资产进行登记、盘点、检索', '管理端：Windows/Mac<br>应用端：Android/iOS 11.3以上', '手机、RFID']
      ]
      // ,
      // price: ['¥20,000起']
    }, {
      name: '生产管理',
      data: [
        ['ERP', '关联人机物等信息，贯通生产、办公数据链', '管理端：Windows/Mac<br>应用端：Android/iOS', '/'],
        ['MES', '将传感器、边缘计算机等智能设备与软件互联互通，实现产线、车间数字化管理', '管理端：Windows/Mac<br>应用端：Android/iOS', '边缘计算机、工位机']
      ],
      // price: ['¥100,000起', '咨询定制']
    }, {
      name: '仓库管理',
      data: [
        ['WMS', '简易化仓储管理，减少仓储成本', '管理端：Windows/Mac<br>应用端：Android/iOS', '超高频设备、RFID、手持机'],
        ['出入库一体化管控系统', '基于条码、二维码、RFID等多信源与红外设备、工业相机、RFID管控装置实现货物跟踪、分拣、出入库管理', '管理端：Windows/Mac<br>应用端：Windows/Android', '工业相机、RFID、超高频设备等']
      ],
      // price: ['咨询定制', '¥15,000起']
    }, {
      name: '园区管理',
      data: [
        ['智慧路灯', '实现路灯与音响、广告屏、充电桩等园区设备的联动', '管理端：Windows/Mac<br>应用端：Android', '照明设备、边缘计算机、继电器、交换机、传感器、音响、显示屏'],
        ['能耗管控', '实时监控园区内各设备能耗', '管理端：Windows/Mac<br>应用端：Android/iOS', '传感器、采集器、天线'],
        ['6S履职巡检', '实现园区内各点位安防巡检，值班人员只需一台手持设备即可独立完成', '管理端：Windows/Mac<br>应用端：Android', '手持机、RFID'],
      ],
      // price: ['¥25,000起', '¥1,500起', '软件免费']
    }, {
      name: '物流管理',
      data: [
        ['AGV智慧物流', '生产驱动AGV运输，实现自动补货、出货', '管理端：Windows/Mac<br>应用端：Android/iOS', 'AGV、平板'],
      ],
      // price: ['¥130,000起']
    }, {
      name: '品牌管理',
      data: [
        ['优羽优选', '赋能服装品牌，提升电商能力和产品销量', '管理端：Windows/Mac<br>应用端：Android/iOS 11.3以上', '/'],
      ],
      // price: ['咨询定制']
    }
  ]
}


export const HOME = {
  POINT: [
    {
      name: '浙江可信物联网技术研究院',
      pos: [244, 176],
      bpos: 1
    }, {
      name: '外来人口及出租屋管理',
      pos: [191, 266],
      bpos: 0
    }, {
      name: '鉴真宝物联网电子商务',
      pos: [379, 379],
      bpos: 1
    }, {
      name: '机动车管理系统',
      pos: [168, 669],
      bpos: 0
    }, {
      name: '鉴真宝物联网电子商务',
      pos: [514, 536],
      bpos: 1
    }, {
      name: '达铃考勤系统',
      pos: [147, 974],
      bpos: 0
    }, {
      name: '资产管理系统',
      pos: [180, 974],
      bpos: 0
    }, {
      name: '会议管理系统',
      pos: [185, 1092],
      bpos: 1
    }, {
      name: '智慧生产管控一体化',
      pos: [264, 961],
      bpos: 0
    }, {
      name: '设计师共享平台',
      pos: [114, 1278],
      bpos: 1
    }, {
      name: '模具共享平台',
      pos: [178, 1278],
      bpos: 1
    }, {
      name: '在线质检系统',
      pos: [252, 1282],
      bpos: 1
    }, {
      name: '鉴真宝数据加密中心',
      pos: [341, 1144],
      bpos: 0
    }, {
      name: 'AGV智慧物流',
      pos: [443, 1058],
      bpos: 0
    }, {
      name: 'WMS仓储系统',
      pos: [431, 1122],
      bpos: 1
    }, {
      name: '出入库管理系统',
      pos: [445, 1280],
      bpos: 1
    }, {
      name: '智能云访客',
      pos: [603, 1032],
      bpos: 0
    }, {
      name: '多信源识别',
      pos: [594, 1283],
      bpos: 1
    }, {
      name: '智慧路灯',
      pos: [379,1380],
      bpos: 0
    }, {
      name: '售后服务平台',
      pos: [150,1561],
      bpos: 0
    }, {
      name: '“优羽”服装工业互联网平台',
      pos: [289, 1625],
      bpos: 0
    }, {
      name: '非机动车管理系统',
      pos: [582,1770],
      bpos: 0
    }
  ],
  STATIC: [
    {
      name: '行政中心',
      pos: [103, 946]
    }, {
      name: '设计中心',
      pos: [103, 1128]
    }, {
      name: '生产车间',
      pos: [213, 946]
    }, {
      name: '质检中心',
      pos: [213, 1115]
    }, {
      name: '物流中心',
      pos: [364, 946]
    }, {
      name: '仓储中心',
      pos: [363, 1115]
    }
  ]
}